// extracted by mini-css-extract-plugin
module.exports = {"vote-container":"index_vote-container__2EhSB","title":"index_title__3zgEO","your-vote":"index_your-vote__2FZ2w","btn-vote":"index_btn-vote__1QhK6"};